const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d3a887ec684c2dc4fc5d62b3ee3eb0b19a005661"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["next@themecloud-o0"]={id:"d3a887ec684c2dc4fc5d62b3ee3eb0b19a005661"};
      